import React from 'react';

export default function StudioBanner() {
  return (
    <div className="bg-purple-100 border-b border-purple-300 px-6 py-2 text-sm text-purple-800 font-medium">
      TEMPLATE STUDIO — Changes here affect future tenant installs only. Existing tenant installs are never affected.
    </div>
  );
}
